import { Alert, type AlertProps } from '@heroui/react';

export const Insight = ({ ...rest }: AlertProps) => {
  return <Alert {...rest} />;
};
